import MultipleSelect, { CustomInput } from './MultipleSelect';

export { CustomInput };
export default MultipleSelect;
